import React from 'react';
import { Icon, Table } from 'semantic-ui-react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../../app/stores/store';
function UpdatesTable() {
  const {commonStore} = useStore();
  
  return (
    <div>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="2">{
              (userLanguage[0].UpdateTable.UT01 as any)?.[`${commonStore.language.key}`]
              }</Table.HeaderCell>
            <Table.HeaderCell width="3">{
              (userLanguage[0].UpdateTable.UT02 as any)?.[`${commonStore.language.key}`]
              }</Table.HeaderCell>
            <Table.HeaderCell width="6">{
              (userLanguage[0].UpdateTable.UT03 as any)?.[`${commonStore.language.key}`]
              }</Table.HeaderCell>
            <Table.HeaderCell width="1">{
              (userLanguage[0].UpdateTable.UT04 as any)?.[`${commonStore.language.key}`]
              }</Table.HeaderCell>
            <Table.HeaderCell width="1">{
              (userLanguage[0].UpdateTable.UT05 as any)?.[`${commonStore.language.key}`]
              }</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>info@honeycombmanager.com</Table.Cell>
            <Table.Cell>2022-05-04 03:59:13.336</Table.Cell>
            <Table.Cell>
              Please Check the film can resceiving for damages
            </Table.Cell>
            <Table.Cell>
              <Icon name="checkmark" />
            </Table.Cell>
            <Table.Cell>
              {' '}
              <Icon name="eye slash" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
}

export default UpdatesTable;
